// =============================================================================
// src/features/copilot-chat/copilot-data-store.ts — Store mutável com overlay ao vivo.
// =============================================================================

import { COPILOT_CHAT_DATA, type CopilotChatDataset } from './copilot-dataset';

let activeData: CopilotChatDataset = COPILOT_CHAT_DATA;

export function getCopilotChatData(): CopilotChatDataset {
  return activeData;
}

export function applyCopilotLiveOverlay(overlay: Partial<CopilotChatDataset>): void {
  activeData = {
    ...activeData,
    ...overlay,
    irm: overlay.irm ?? activeData.irm,
    threatGeral: overlay.threatGeral ?? activeData.threatGeral,
    threatTema: overlay.threatTema ?? activeData.threatTema,
    sentimento: overlay.sentimento ?? activeData.sentimento,
    feed: overlay.feed ?? activeData.feed,
    diagnostico: overlay.diagnostico ?? activeData.diagnostico,
    stakeholders: overlay.stakeholders ?? activeData.stakeholders,
    plano: overlay.plano ?? activeData.plano,
    evolucao: overlay.evolucao ?? activeData.evolucao,
    shareOfVoice: overlay.shareOfVoice ?? activeData.shareOfVoice,
    linhaTempo: overlay.linhaTempo ?? activeData.linhaTempo,
    volumeCanal: overlay.volumeCanal ?? activeData.volumeCanal,
  };
}

/** TEST-ONLY */
export function __resetCopilotDataForTests(): void {
  activeData = COPILOT_CHAT_DATA;
}
